var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.test)+"\n  "),_c('div',{ref:_vm.chartName,style:({height:_vm.height,width:_vm.width})})])}
var staticRenderFns = []

export { render, staticRenderFns }